import { PersonaQuizBlockData } from 'api/cms';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { AmpPersonaQuizBlock } from './AmpPersonaQuizBlock';
import { PersonaQuizBlock } from './PersonaQuizBlock';

export const PersonaQuizBlockMapping: BlockMapping<PersonaQuizBlockData> = {
  invariant: [],
  width: 'GRID',
  Component: PersonaQuizBlock,
  AmpComponent: AmpPersonaQuizBlock,
};
